import { createSelector } from 'reselect';
import { getEaTravelRates } from './index';
import { API_CALL_STATUS } from '../../reducers/status';

export const getUpdateDetails = createSelector(getEaTravelRates, (travelInsurance) => travelInsurance?.update);

export const getIsApiPending = createSelector(
    getUpdateDetails,
    (updateDetails) =>
        updateDetails.apiCallStatus === API_CALL_STATUS.PENDING ||
        updateDetails.updateApiCallStatus === API_CALL_STATUS.PENDING ||
        updateDetails.exchangeListApiCallStatus === API_CALL_STATUS.PENDING
);

export const getUpdateApiCallStatus = createSelector(
    getUpdateDetails,
    (updateDetails) => updateDetails?.updateApiCallStatus
);
export const getExchangeData = createSelector(getUpdateDetails, (updateDetails) => updateDetails.exchangeData);

export const getUpdateForm = createSelector(getUpdateDetails, (updateDetails) => updateDetails.form);

const makeGetFormField = (fieldId) => createSelector(getUpdateForm, (form) => form[fieldId]);

export const getFromCurrencyValue = makeGetFormField('fromCurrency');
export const getToCurrencyValue = makeGetFormField('toCurrency');
export const getExchangeRateValue = makeGetFormField('exchangeRate');
export const getActiveExchangeRateValue = makeGetFormField('activeExchangeRate');
export const getLastUpdatedExchangeRateValue = makeGetFormField('lastUpdatedExchangeRate');
